<template>
  <div v-if="covertIng" id="html-canvas" class="detail nopd">
    <div class="top flex flex-align-center">
      <a
        class="flex flex-align-center"
        @click="$go('Mypost', { query: { ...detail.UserInfo } })"
      >
        <van-image
          fit="cover"
          height="50"
          round
          :src="$getAvatar(detail.UserInfo && detail.UserInfo.Avatar)"
          width="50"
        />
        <h2>{{ detail.UserInfo && detail.UserInfo.NickName }}</h2>
      </a>
    </div>
    <div class="bd">
      <h1>{{ detail.Title }}</h1>
      <div class="detail-bd">
        <div
          class="text"
          v-html="detail.Text ? detail.Text.replace(/\n/g, '<br/>') : ''"
        ></div>
        <div class="image">
          <ul class="img-list">
            <li v-for="(item, key) in detail.Image" :key="key" class="">
              <img crossorigin="anonymous" :src="api.FileHost + item" />
            </li>
          </ul>
        </div>
      </div>
      <div class="code flex flex-align-center flex-pack-center">
        <div class="txt">
          <p>长按识别二维码了解更多</p>
          <p>一起加入【{{ getCaseName }}】吧</p>
        </div>
        <div>
          <div id="qrcode" ref="qrcode" class="qrcode"></div>
        </div>
        <!-- <div style="height: 10px"></div> -->
      </div>
    </div>
  </div>
  <div v-else>
    <img v-if="imgUri" :src="imgUri" />
    <div class="reset-box">
      如果生成的图片不完整
      <a class="reset" href="javascript:;" @click="reload">点击这里</a>
      重新生成
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast } from 'vant'
  import api from '@/api'
  //import html2canvas from 'html2canvas'
  import html2canvas from '@/utils/html2canvas'
  import QRCode from 'qrcodejs2'
  //import domtoimage from 'dom-to-image'
  export default {
    data() {
      return {
        detail: {},
        api,
        covertIng: true,
        imgUri: '',
        getCaseName: store.getters['user/getCaseName'],
      }
    },
    created() {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    methods: {
      reload() {
        window.location.reload()
      },
      async init() {
        const id = this.$route.params.id
        Toast.loading({
          duration: 0,
          message: '生成图片中...',
          forbidClick: false,
          overlay: true,
        })
        await this.getDetail(id)
        let url = ''
        const wxurl = await store.getters['system/getH5Url']
        url = `${wxurl}case/#/case/detail/${id}?from='case-img-share'`
        await this.crateQrcode(url)
        this.covertIng = true
        await this.checkImgOnload()
        setTimeout(() => {
          // canvas方案
          this.toImg()
        }, 1000)
        //this.domToImg()
      },
      checkImgOnload() {
        return new Promise((resolve, reject) => {
          const detail = this.detail
          const imgList = JSON.parse(JSON.stringify(detail.Image))
          if (detail.UserInfo && detail.UserInfo.Avatar) {
            imgList.push(detail.UserInfo.Avatar)
          }

          const len = imgList.length
          let load = 0
          for (let i = 0; i < len; i++) {
            const img = new Image()
            //设置图片跨域访问
            img.setAttribute('crossOrigin', 'anonymous')
            img.src = api.FileHost + imgList[i]
            img.onload = () => {
              load++
              if (load == len) resolve()
            }
            img.onerror = () => {
              load++
              if (load == len) resolve()
            }
          }
        })
      },
      async toImg() {
        var realHtml = document.getElementById('html-canvas') //需要截图的包裹的（原生的）DOM 对象
        // var width = realHtml.offsetWidth //获取dom 宽度
        // var height = realHtml.offsetHeight + 500 //获取dom 高度
        // var canvas = document.createElement('canvas') //创建一个canvas节点
        // var scale = 2 //定义任意放大倍数 支持小数
        // canvas.width = width * scale //定义canvas 宽度 * 缩放
        // canvas.height = height * scale //定义canvas高度 *缩放
        // canvas.getContext('2d').scale(scale, scale) //获取context,设置scale
        var opts = {
          width: parseInt(realHtml.offsetWidth),
          height: parseInt(realHtml.offsetHeight + 10),
          allowTaint: false,
          taintTest: true,
          useCORS: true,
          tainttest: true, //检测每张图片都已经加载完成
          scale: 2, // 设备像素比
          ignoreElements: (element) => {
            // 可从渲染中删除匹配的元素
            if (element.className === 'exclude') return true
          },
        }

        await (window.html2canvas || html2canvas)(realHtml, opts)
          .then((res) => {
            const url = res.toDataURL('image/jpeg', 0.8)
            this.imgUri = url
            this.covertIng = false
            Toast.success('生成图片成功长按图片下载')
          })
          .catch((e) => {
            this.covertIng = false
            alert('生成图片失败' + e)
          })
      },
      // async domToImg() {
      //   var node = document.getElementById('html-canvas') //需要截图的包裹的（原生的）DOM 对象
      //   // options 可不传
      //   var options = {}

      //   domtoimage
      //     .toJpeg(node, options)
      //     .then((dataUrl) => {
      //       this.covertIng = false
      //       // var img = new Image()
      //       // img.src = dataUrl
      //       // document.body.appendChild(img)
      //       this.imgUri = dataUrl
      //       Toast.success('生成图片成功长按图片下载')

      //       // var link = document.createElement('a')
      //       // link.download = 'my-image-name.jpeg'
      //       // link.href = dataUrl
      //       // link.click()
      //     })
      //     .catch(function (error) {
      //       this.covertIng = false
      //       alert('生成图片失败' + error)
      //       console.error('oops, something went wrong!', error)
      //     })
      // },
      getDetail(id) {
        return store
          .dispatch('case/PostGet', { id })
          .then(async (data) => {
            const { Data } = data
            this.detail = Data
            await this.getUserInfo(Data.CreatedBy)
          })
          .catch((e) => {
            Toast.fail('获取数据失败，请稍后再试')
          })
      },
      async getUserInfo(id) {
        const tenant = await store.getters['user/getTenant']
        return store
          .dispatch('user/GetUserList', {
            tenantId: tenant.TenantId,
            userIDs: [id],
          })
          .then((data) => {
            this.detail.UserInfo = data.Data[0]
          })
          .catch((e) => {
            Toast.clear()
          })
      },
      // 生成二维码
      crateQrcode(text) {
        this.$refs.qrcode.innerHTML = ''
        return new Promise((resolve, reject) => {
          const qr = new QRCode('qrcode', {
            width: 100,
            height: 100, // 高度
            text: text, // 二维码内容
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.L,
          })
          resolve(qr)
        })
        // console.log(qr)
        // console.log(qr._el.lastChild.currentSrc)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .detail {
    background: #fff;
    min-height: 100vh;
    .bd {
      padding: 16px 20px;
    }
    .detail-bd {
      min-height: 66vh;
    }

    h1 {
      margin-top: 0;
      border-top: 1px solid #fff;
      font-size: 18px;
      //text-align: center;
      margin-bottom: 16px;
      line-height: 1.6;
    }
    .text {
      font-size: 16px;
      line-height: 1.6;
    }
    .img-list {
      margin-top: 10px;
      li {
        margin-bottom: 7px;
      }
    }
    .top {
      padding: 10px 16px 10px 16px;
      background: #fff;
      border-bottom: 1px solid #f1f1f1;
      a {
        color: #333;
      }
      h2 {
        margin: 0 0 0 10px;
        font-size: 16px;
        color: #b57e48;
      }
      .back {
        padding: 10px 12px;
      }
    }
  }
  img {
    max-width: 100%;
  }
  .qrcode {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
  .code {
    border-top: 1px solid #f1f1f1;
    margin-top: 16px;
    padding-top: 16px;
    .txt {
      font-size: 14px;
      color: #666;
      padding: 0 16px 0 0;
    }
  }

  ::v-deep .tag-stress {
    font-style: normal;
    //text-decoration: underline;
    border: none;
    color: #b57e48;
    font-weight: bold;
  }

  .reset-box {
    text-align: center;
    padding: 16px 0 36px;
    font-size: 14px;
    color: #999;
    .reset {
      font-size: 16px;
      color: #b57e48;
      font-weight: bold;
    }
  }
  // ::v-deep .tag-stress :after {
  //   content: '';
  //   position: absolute;
  //   bottom: -2px;
  //   left: 5%;
  //   width: 90%;
  //   height: 2px;
  //   background: -webkit-linear-gradient(
  //       315deg,
  //       transparent,
  //       transparent 45%,
  //       red 55%,
  //       transparent 55%,
  //       transparent 100%
  //     ),
  //     -webkit-linear-gradient(45deg, transparent, transparent 45%, red 55%, transparent
  //           55%, transparent 100%);
  //   background-size: 4px 4px;
  //   background-repeat: repeat-x;
  // }
</style>
